<template>
  <div class="organisations">
    <data-table
      header-icon="form-organisation-apioshade3"
      header-text="Organisations"
      :show-filter="true"
      :headers="fields"
      :items="organisations"
      :loaded="loaded"
    >
      <div slot="activator" v-if="$mq === 'small' || $mq === 'medium' || $mq === 'large'"
        ><apio-button button-size="small">
          NEW<apio-icon
                name="ui-org-new"
                class="ml-2"
                size="28"
                darkModeColour="white"
                lightModeColour="white"
              />
       </apio-button
      ></div>
      <div slot="add" v-else
        ><apio-button @click="addOrg"
          >New
          <apio-icon
                name="ui-org-new"
                class="ml-2"
                size="28"
                darkModeColour="white"
                lightModeColour="white"
              /></apio-button
      ></div>
      <template v-slot:[`item.show_details`]="{ item }">
        <div
          style="display: flex; justify-content: flex-end; cursor: pointer;"
          :ripple="false"
          @click="editOrg(item.ID)"
        >
          <apio-icon name="ui-edit"></apio-icon>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Organisations",
  components: {
    ApioButton: () => import("@/components/Misc/Button.vue"),
    DataTable: () => import("@/components/DataTable/DataTable.vue"),
  },
  data: () => ({
    loaded: false,
    search: "",
    searchTerm: "",
    dialog: "",
    modalStatus: false,
    modalMode: "",
    addShowing: false,
    headerText: "Organisations",
    tableSearchIcon: "fa-search",
    fields: [
      {
        value: "name",
        text: "Organisation name",
      },
      {
        value: "apps",
        text: "Apps",
      },
      {
        value: "interfaces",
        text: "Interfaces",
      },
      {
        value: "show_details",
        text: "",
      },
    ],
  }),
  mounted() {
    this.$on("toggleDialog", (value) => this.toggleDialog(value));
  },
  computed: {
    ...mapState({
      organisations: (state) => state.orgs.orgs || [],
    }),
    noOrganisations() {
      return !this.organisations || !this.organisations.length;
    },
  },
  methods: {
    toggleDialog(value, modalMode, item) {
      this.edituser = item;
      this.dialog = value;
      this.modalMode = modalMode;
    },
    filter(searchTerm) {
      this.search = searchTerm;
      this.$emit("filter", this.searchTerm);
    },
    addOrg() {
      this.$router.push("/orgs/add");
    },
    editOrg(id) {
      this.$router.push(`/orgs/edit/${id}`);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.$store.dispatch("fetchOrganisations");
      vm.loaded = true;
    })
  },
};
</script>

<style lang="scss" scoped>
.organisations {
  &__add-button {
    margin: 0 12px;
    width: 32px;
    height: 32px;
    display: flex;

    &--mobile {
      background: var(--apio-cyan);
      background-size: cover;
      border-radius: 50%;
      margin: 0 12px;
      height: 32px;
      width: 32px;
      position: relative;

      & > .icon-24.grunticon__icon-ui-plus-white {
        position: relative;
        top: 4px;
        left: 4px;
      }
    }
  }
}

@media (min-width: 1023px) {
  .organisations {
    &__add-button {
      margin: 0 12px;
      width: fit-content;
      height: 48px;
    }
  }
}
</style>